module.exports = __webpack_public_path__ + "static/img/temp-pc-main01@m.59c8db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-pc-main01@m.jpg
// module id = SdQh
// module chunks = 0